// removed by extract-text-webpack-plugin
module.exports = {"icons":"_31rQzxbGyIIjiY6a36q5uA","icon":"ESRzTHAva8vjfHYKdpYDz"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-503db8bc","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/ContactButtons.less
// module id = 0bbF
// module chunks = 1